import { ProgressBar } from "@/components/ui"
import type { OrderProgressTone } from "@/lib/order-status"

type OrderProgressBarProps = {
  /** 0–100 percentage of the order lifecycle (see getProgressPercent). */
  progress: number
  /** Semantic tone from `getProgressTone`. */
  progressTone: OrderProgressTone
  /** Accessible name of the progressbar. */
  label?: string
  className?: string
}

/**
 * Thin status progress bar shared by the active-order banner and the
 * order status card.
 */
export function OrderProgressBar({ progress, progressTone, label = "Progresso do pedido", className }: OrderProgressBarProps) {
  return (
    <ProgressBar
      value={progress / 100}
      tone={progressTone}
      size="xs"
      label={label}
      className={className}
    />
  )
}

export default OrderProgressBar
